import script from "./AddNewPOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewPOrder.vue?vue&type=script&setup=true&lang=js"

import "./AddNewPOrder.vue?vue&type=style&index=0&id=5de89540&lang=css"

const __exports__ = script;

export default __exports__